import Controls from "@/HOC/Controls/Controls";
import { FC, useState } from "react";
import { ICallingLineControls } from "./CallingLineControls.props";
import { ScreenLock } from "@/components";
import { useTranslate } from "@/hooks";

const CallingLineControls: FC<ICallingLineControls> = ({ setShowPage, leftSection, rightSection, hint = "", ...props }) => {
	const translate = useTranslate(); // hook для перевода текста

	const [showScreenLock] = useState<{ isShow: boolean; title: string }>({ isShow: false, title: "" }); // показ экрана блокировки и подпись

	return (
		<>
			<Controls hint={hint} header="cls" setShowPage={setShowPage} leftSection={leftSection} rightSection={rightSection} {...props} />

			{showScreenLock.isShow && <ScreenLock title={translate(showScreenLock.title)} />}
		</>
	);
};

export default CallingLineControls;
